var _defs, _rect, _line, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.underline-a,.underline-b{fill:none;}.underline-b{stroke:#484848;stroke-linecap:round;}.underline-c{fill:#484848;}\n\t\t"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "underline-a",
    width: 24,
    height: 24,
    rx: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "underline-b",
    x2: 8,
    transform: "translate(8 17.5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.432 -399.131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "underline-c",
    d: "M354.433,406.418a.715.715,0,0,1,.727-.687.7.7,0,0,1,.713.687v4.92a2.56,2.56,0,1,0,5.12,0v-4.92a.716.716,0,0,1,.728-.687.7.7,0,0,1,.712.687v4.948c0,2.281-1.326,3.765-3.993,3.765s-4.007-1.5-4.007-3.751Z",
    transform: "translate(0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underlineIcon.095c8d0c40416a726f9702562d291cbc.svg";
export { ForwardRef as ReactComponent };